import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ILandingSection, TabsContent } from "src/modules/pe-landing-module/data/interfaces"
import { TabsPrimitive } from "../primitive"
import { setHorizontalAlignToCSSRule, setVerticalAlignToCSSRule } from "../section/Section"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface ITabsProps {
    section: ILandingSection
    data: TabsContent  
}
const Tabs = ({data, section, ...props}: ITabsProps): JSX.Element => {
    const [width]           = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]        = useState<string>(getCssDemention( data.height, "fit-content" ))
    const horizontalAlign   = useState<string>( setHorizontalAlignToCSSRule( data?.horizontal_align ||ALIGN.MIDDLE) )
    const vertical_align   = useState<string>( setVerticalAlignToCSSRule( data?.vertical_align ||ALIGN.MIDDLE) )
    useEffect(() => {
        addCSSClass(
            `landing-tabs-${section.id}`,
            `.landing-tabs-${section.id} { 
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                ${horizontalAlign}
                ${vertical_align}
                z-index:1;
                .bp5-tab-panel {
                    width: 100%;
                }
            } 
            `
        )
        return () => {
            removeCSSClass(`landing-tabs-${section.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[  ])
    
    return true
        ?
        <div className={`pe-html-container landing-content-container`} data-type={data.type} data-content-id={data.id}>
            <div className={`landing-tabs landing-tabs-${ section.id } ${ data.className || "" } `} >
                <TabsPrimitive primitive={{ ...data as any }} />
            </div>
            <DataContentEditor data={data} section={section} />
        </div>
        :
        <Dummy {...{ 
            ...{
                data: {
                    ...data,
                    className: ` ${data.className} landing-tabs-${ section.id } `
                },
            }, 
            ...props 
        }} />
}
export default Tabs